import { render } from "./App.vue?vue&type=template&id=fc674cb0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=fc674cb0&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.16_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__